import { AHText, Box, Card } from "arkh";
import React from "react";

import { RoutineOccasionScreenRoutineDescription_Routine$key } from "./__generated__/RoutineOccasionScreenRoutineDescription_Routine.graphql";
import { RoutineOccasionDescriptionContent } from "./RoutineOccasionDescriptionContent";
import { graphql, useFragment } from "react-relay";
import { FormattedMessage } from "react-intl";
import { OrgButton } from "../../OrgHome/OrgButton";

export const RoutineOccasionScreenRoutineDescription = React.memo(
  InnerRoutineOccasionScreenRoutineDescription
);

function InnerRoutineOccasionScreenRoutineDescription(props: {
  routine: RoutineOccasionScreenRoutineDescription_Routine$key;
  children?: React.ReactNode;
  onCustomise?(): void;
  hasRoutineAdmin: boolean;
}) {
  const routine = useFragment(
    graphql`
      fragment RoutineOccasionScreenRoutineDescription_Routine on Routine {
        title
        isOrg

        ...RoutineOccasionDescriptionContent_Routine
      }
    `,
    props.routine
  );

  const hasRoutineAdmin = props.hasRoutineAdmin;
  return (
    <Box spaceBottom="xlarge">
      <Box
        color="surface"
        cornerRadius="large"
        spaceVertical="medium"
        spaceHorizontal="medium"
        cornerRadiusTopLeft="none"
        cornerRadiusTopRight="none"
        style={{ marginTop: -1000 }}
        insets={{ top: 1000 }}
      >
        {props.onCustomise && routine.isOrg && hasRoutineAdmin ? (
          <Box spaceBottom="medium">
            <Card defaultBorder>
              <Box
                style={{
                  flexDirection: "row",
                  flex: 1,
                  alignItems: "center",
                }}
              >
                <AHText
                  spaceRight="medium"
                  type="body"
                  style={{ flex: 1, flexWrap: "wrap" }}
                >
                  <FormattedMessage
                    defaultMessage="Customise the checklist to your needs. Reorder and remove optional sections."
                    description="RoutineOccasionScreenRoutineDescription:CustomiseChecklistDescription"
                  />
                </AHText>
                <OrgButton
                  title={
                    <FormattedMessage
                      defaultMessage="Customise"
                      description="RoutineOccasionScreenRoutineDescription:Customise"
                    />
                  }
                  backgroundColor="surface-backgroundControl"
                  tintColor="text-primary"
                  onPress={props.onCustomise}
                />
              </Box>
            </Card>
          </Box>
        ) : null}
        <Box spaceBottom="small">
          <AHText spaceHorizontal="medium" type="title-big">
            {routine.title}
          </AHText>
          <RoutineOccasionDescriptionContent routine={routine} />
        </Box>
        {props.children}
      </Box>
    </Box>
  );
}
